import "clsx";
import "@sveltejs/kit/internal";
import "../../../chunks/exports.js";
import "../../../chunks/utils.js";
import "../../../chunks/client2.js";
import "ts-deepmerge";
import "../../../chunks/formData.js";
import { error } from "@sveltejs/kit";
import { s as superValidate, f as fail, m as message } from "../../../chunks/superValidate.js";
import "memoize-weak";
import { l as valibot, j as getLinkSchema, m as getString, n as isPublicLink, o as emptyStringToNull, g as invalid_private_link } from "../../../chunks/valibot.js";
import "zod-to-json-schema";
import { g as getDB, l as link } from "../../../chunks/index3.js";
import { c as createAndLoginTempUser } from "../../../chunks/auth.server.js";
import { and, eq, or, gte, isNull } from "drizzle-orm";
import { nanoid } from "nanoid";
import { S as SHORTEN_LENGTH } from "../../../chunks/defaults.js";
import { b as private_env, p as public_env } from "../../../chunks/shared-server.js";
import "../../../chunks/runtime.js";
import { u as unsecure_link } from "../../../chunks/unsecure_link.js";
const ORIGIN = private_env.ORIGIN ?? void 0;
const version = "2.10.0";
const googleSafeBrowsing = async (url) => {
  if (private_env.GOOGLE_SAFE_BROWSING_API_KEY === void 0) {
    console.warn("GOOGLE_SAFE_BROWSING_API_KEY is not defined");
    return true;
  }
  const googleSafeBrowsing2 = new URL("https://safebrowsing.googleapis.com/v4/threatMatches:find");
  googleSafeBrowsing2.searchParams.append("key", private_env.GOOGLE_SAFE_BROWSING_API_KEY);
  const response = await fetch(googleSafeBrowsing2, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
      client: {
        clientId: "shrtn",
        clientVersion: version
      },
      threatInfo: {
        platformTypes: ["ANY_PLATFORM"],
        threatTypes: [
          "MALWARE",
          "SOCIAL_ENGINEERING",
          "UNWANTED_SOFTWARE",
          "POTENTIALLY_HARMFUL_APPLICATION"
        ],
        threatEntryTypes: ["URL"],
        threatEntries: [{ url }]
      }
    })
  });
  if (!response.ok) {
    console.error("API Error:", response.status, await response.text());
    return false;
  }
  const result = await response.json();
  return typeof result === "object" && (result.matches == null || result.matches?.length === 0);
};
const saveLink = async (data, counter = 5) => {
  const db = getDB();
  try {
    await db.insert(link).values([data]).run();
    const { passphrase, id, ...restData } = data;
    return {
      ...restData,
      key: id,
      hasPassphrase: !!passphrase
    };
  } catch (err) {
    if (err != null && typeof err === "object" && !Array.isArray(err) && "code" in err && err.code === "SQLITE_CONSTRAINT_PRIMARYKEY") {
      const id = nanoid(SHORTEN_LENGTH + (5 - counter));
      return saveLink({ ...data, id }, counter - 1);
    } else {
      throw err;
    }
  }
};
const load = async ({ locals, request }) => {
  const db = getDB();
  const origin = ORIGIN || request.headers.get("origin");
  if (!origin) {
    error(400, "Origin header is missing");
  }
  const form = superValidate(valibot(getLinkSchema(!!locals.user && !locals.user.temp)));
  if (!locals.user) {
    return {
      links: [],
      form: await form,
      origin
    };
  }
  const data = await db.select({
    url: link.url,
    key: link.id,
    passphrase: link.passphrase,
    calls: link.calls,
    callLimit: link.callLimit,
    createdAt: link.createdAt,
    expiresAt: link.expiresAt
  }).from(link).where(
    and(
      eq(link.userId, locals.user.id),
      or(gte(link.expiresAt, /* @__PURE__ */ new Date()), isNull(link.expiresAt))
    )
  ).all();
  return {
    origin,
    links: data.map((link2) => ({
      key: link2.key,
      url: link2.url,
      hasPassphrase: !!link2.passphrase,
      calls: link2.calls,
      callLimit: link2.callLimit,
      createdAt: link2.createdAt,
      expiresAt: link2.expiresAt
    })),
    form: await form
  };
};
const actions = {
  add: async (event) => {
    const { locals, request } = event;
    let { user } = locals;
    if (user == null) {
      ({ user } = await createAndLoginTempUser(event));
    }
    const LinkSchema = getLinkSchema(!user.temp);
    const form = await superValidate(request, valibot(LinkSchema));
    if (!form.valid) {
      return fail(400, { form });
    }
    if (public_env.PUBLIC_FEATURE_PRIVATE_LINKS !== "on" && !await isPublicLink(form.data.link)) {
      return message(form, invalid_private_link(), { status: 400 });
    }
    if (!await googleSafeBrowsing(form.data.link)) {
      return message(form, unsecure_link(), { status: 400 });
    }
    const { ttl, link: url, short, passphrase, callLimit } = form.data;
    const expiresAt = ttl == null ? null : new Date(Date.now() + ttl);
    const linkData = await saveLink({
      id: short || nanoid(SHORTEN_LENGTH),
      userId: user.id,
      url,
      passphrase: emptyStringToNull(passphrase) ?? null,
      callLimit: callLimit ?? null,
      calls: null,
      createdAt: /* @__PURE__ */ new Date(),
      expiresAt
    });
    return { success: true, data: linkData, form };
  },
  remove: async ({ locals, request }) => {
    const { user } = locals;
    const db = getDB();
    if (user == null) {
      return error(401, "Not Authenticated");
    }
    const data = await request.formData();
    const key = getString(data.get("key"));
    await db.delete(link).where(and(eq(link.id, key), eq(link.userId, user.id))).run();
    return { success: true };
  }
};
export {
  actions,
  load
};
